import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL;
// If REACT_APP_API_URL is provided it already includes /api (per .env.example
// for production). REACT_APP_BACKEND_URL is the legacy var pointing at the
// origin — we append /api ourselves in that case.
export const API = process.env.REACT_APP_API_URL
  ? BACKEND_URL
  : `${BACKEND_URL}/api`;

// Auth uses httpOnly cookies set by the backend on /auth/login.
// withCredentials ensures the browser sends those cookies on every request.
// NOTE: do NOT set a default Content-Type — axios auto-detects per request
// (JSON vs multipart/form-data).
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// In-memory Bearer fallback. Some browsers (or strict privacy settings)
// silently drop cookies on subsequent same-origin requests after Set-Cookie.
// To keep the app usable in those environments WITHOUT introducing the XSS
// risk of localStorage, we keep the access token in module-scoped memory only
// (cleared on tab close / refresh). The token is set by AuthContext after a
// successful /auth/login, and cleared on logout or session expiry.
let bearerToken = null;
export function setBearerToken(token) {
  bearerToken = token || null;
}
export function clearBearerToken() {
  bearerToken = null;
}

api.interceptors.request.use((config) => {
  if (bearerToken) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${bearerToken}`;
    }
  }
  return config;
});

// AuthProvider can register a handler for explicit /auth/me 401s if it wants
// to soft-clear state. We intentionally do NOT auto-clear on every 401 — that
// caused login → dashboard → bounce-back-to-login loops on transient failures.
let onSessionExpired = null;
export function setSessionExpiredHandler(fn) {
  onSessionExpired = fn;
}
export function notifySessionExpired() {
  if (typeof onSessionExpired === "function") onSessionExpired();
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
